export function isValidInstagramPostUrl(url: string): boolean {
    const instagramPostUrlPattern = /^https:\/\/(www\.)?instagram\.com\/(p|reels?|share)\/[A-Za-z0-9_-]+\/?$/;
    return instagramPostUrlPattern.test(url);
}

export function sanitizeInstagramPostUrl(url: string): string {
    const urlWithoutQueryParams = url.split('?')[0];

    const urlWithHttps = urlWithoutQueryParams.startsWith('https://')
        ? urlWithoutQueryParams
        : `https://${urlWithoutQueryParams}`;

    return urlWithHttps.startsWith('https://www.') ? urlWithHttps : urlWithHttps.replace('https://', 'https://www.');
}
